(function () {
  const initProductAccordion = () => {
		const $root = arguments.length > 0 ? $(arguments[0]) : $(document);

		$root
			.find(".about__accordion-toggle")
			.off("click.pkAccordion")
			.on("click.pkAccordion", function () {
				const $toggle = $(this);
				const $desc = $toggle.siblings(".about__accordion-description");

				if (!$toggle.hasClass("active")) {
					$toggle.addClass("active");
					$desc.stop(true, true).slideDown(300);
				} else {
					$toggle.removeClass("active");
					$desc.stop(true, true).slideUp(300);
				}
			});

		$root.find('section[id^="MainProduct-"]').each(function () {
			const $section = $(this);

			const openFirst =
				String($section.attr("data-open-first-dropdown-information")).toLowerCase() === "true";

			let $targetToggle = $section
				.find('.about[data-accordion-default-open="true"] .about__accordion-toggle')
				.first();

			if (!$targetToggle.length && openFirst) {
				$targetToggle = $section.find(".about__accordion-toggle").first();
			}

			if ($targetToggle.length && !$targetToggle.hasClass("active")) {
				$targetToggle.addClass("active");
				$targetToggle.siblings(".about__accordion-description").stop(true, true).slideDown(0);
			}
		});
  };

  const initZoomImage = () => {
    const imagesWrapper = document.querySelector('.product-media-modal__content');
    const images = imagesWrapper.querySelectorAll('.js-image-zoom');

    images.forEach(el => {
      el.addEventListener('click', (e) => {
        imagesWrapper.classList.toggle('zoom');
      });
    })
  };

  const initSizeChartModalFromHash = () => {
    // Check if URL hash matches size chart modal
    const hash = window.location.hash.substring(1); // Remove the #
    if (hash === 'size-chart') {
      const modal = document.querySelector('modal-dialog[data-modal-hash="size-chart"]');
      if (modal && !modal.hasAttribute('open')) {
        // Small delay to ensure modal is ready
        setTimeout(() => {
          modal.show();
        }, 100);
      }
    } else if (hash === 'universal-size-chart') {
      let modal = document.querySelector('modal-dialog[data-modal-hash="universal-size-chart"]');
      if (!modal) {
        modal = document.querySelector('#UniversalSizingChartModal, #UniversalSizingChartModalFooter');
      }
      if (modal && !modal.hasAttribute('open')) {
        // Small delay to ensure modal is ready
        setTimeout(() => {
          modal.show();
        }, 100);
      }
    } else if (hash === 'universal-position-chart') {
      let modal = document.querySelector('modal-dialog[data-modal-hash="universal-position-chart"]');
      if (!modal) {
        modal = document.querySelector('#UniversalPositionChartModal, #UniversalPositionChartModalFooter');
      }
      if (modal && !modal.hasAttribute('open')) {
        // Small delay to ensure modal is ready
        setTimeout(() => {
          modal.show();
        }, 100);
      }
    }
  };

  // Global click handler using event delegation for size chart links
  const handleSizeChartClick = (e) => {
    const link = e.target.closest('a');
    if (!link) return;
    
    const href = link.getAttribute('href') || '';
    // Get text from link, handling cases where text might be in child elements
    let linkText = '';
    const textNode = link.querySelector('span') || link;
    linkText = (textNode.textContent || link.textContent || '').toLowerCase().trim();
    
    // Check if link contains #size-chart or #universal-size-chart in href or text matches "size chart"
    const isSizeChartLink = href.includes('#size-chart') || 
                           href.endsWith('#size-chart') ||
                           href === '#size-chart' ||
                           href === '/#size-chart' ||
                           (linkText.includes('size chart') && (href === '#' || href === '#size-chart' || href.startsWith('#')));
    
    const isUniversalSizeChartLink = href.includes('#universal-size-chart') || 
                                     href.endsWith('#universal-size-chart') ||
                                     href === '#universal-size-chart' ||
                                     href === '/#universal-size-chart';
    
    const isUniversalPositionChartLink = href.includes('#universal-position-chart') || 
                                         href.endsWith('#universal-position-chart') ||
                                         href === '#universal-position-chart' ||
                                         href === '/#universal-position-chart';
    
    if (isSizeChartLink) {
      const modal = document.querySelector('modal-dialog[data-modal-hash="size-chart"]');
      if (modal) {
        e.preventDefault();
        e.stopPropagation();
        modal.show();
        return false;
      } else {
        // If modal doesn't exist, check if we're on a product page
        // If so, prevent navigation and wait for modal to load
        if (document.querySelector('section[id^="MainProduct-"]')) {
          e.preventDefault();
          e.stopPropagation();
          setTimeout(() => {
            const modalDelayed = document.querySelector('modal-dialog[data-modal-hash="size-chart"]');
            if (modalDelayed) {
              modalDelayed.show();
            }
          }, 300);
          return false;
        }
      }
    } else if (isUniversalSizeChartLink) {
      // Try to find modal by hash first, then by ID
      let modal = document.querySelector('modal-dialog[data-modal-hash="universal-size-chart"]');
      if (!modal) {
        modal = document.querySelector('#UniversalSizingChartModal, #UniversalSizingChartModalFooter');
      }
      if (modal) {
        e.preventDefault();
        e.stopPropagation();
        modal.show();
        return false;
      } else {
        // If modal doesn't exist, wait for modal to load
        e.preventDefault();
        e.stopPropagation();
        setTimeout(() => {
          let modalDelayed = document.querySelector('modal-dialog[data-modal-hash="universal-size-chart"]');
          if (!modalDelayed) {
            modalDelayed = document.querySelector('#UniversalSizingChartModal, #UniversalSizingChartModalFooter');
          }
          if (modalDelayed) {
            modalDelayed.show();
          }
        }, 300);
        return false;
      }
    } else if (isUniversalPositionChartLink) {
      // Try to find modal by hash first, then by ID
      let modal = document.querySelector('modal-dialog[data-modal-hash="universal-position-chart"]');
      if (!modal) {
        modal = document.querySelector('#UniversalPositionChartModal, #UniversalPositionChartModalFooter');
      }
      if (modal) {
        e.preventDefault();
        e.stopPropagation();
        modal.show();
        return false;
      } else {
        // If modal doesn't exist, wait for modal to load
        e.preventDefault();
        e.stopPropagation();
        setTimeout(() => {
          let modalDelayed = document.querySelector('modal-dialog[data-modal-hash="universal-position-chart"]');
          if (!modalDelayed) {
            modalDelayed = document.querySelector('#UniversalPositionChartModal, #UniversalPositionChartModalFooter');
          }
          if (modalDelayed) {
            modalDelayed.show();
          }
        }, 300);
        return false;
      }
    }
  };
  
  // Add global click listener using event delegation
  document.addEventListener('click', handleSizeChartClick, true);

  // Check hash on page load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      initSizeChartModalFromHash();
    });
  } else {
    initSizeChartModalFromHash();
  }

  // Also check hash when navigating (for SPA-like navigation)
  window.addEventListener('hashchange', initSizeChartModalFromHash);

  document.addEventListener('shopify:section:load', function (event) {
    initProductAccordion(event.target);
    initZoomImage();
    initSizeChartModalFromHash();
  });

  initProductAccordion();
  initZoomImage();
})();
